import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { BsFileEarmarkPdf, BsFiletypeCsv } from "react-icons/bs";
import { useCurrency } from '../../Layouts/currencyContext';
import { FaFileCircleExclamation } from "react-icons/fa6";
import { BarLoader, ClipLoader } from 'react-spinners';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import "react-datepicker/dist/react-datepicker.css";
import ApiService from '../../services/apiService';
import Pagination from '../pagination/pagination';
import { PiDownloadSimple } from "react-icons/pi";
import { useLocation } from "react-router-dom";
import { LiaFileExcel } from "react-icons/lia";
import { RiRefreshLine } from "react-icons/ri";
import 'ag-grid-community/styles/ag-grid.css';
import DatePicker from 'react-datepicker';
import Modal from 'react-bootstrap/Modal';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { jsPDF } from 'jspdf';
import * as XLSX from "xlsx";
import moment from 'moment';
import 'jspdf-autotable';
import "./reports.css"
const REPORT_URL = process.env.REACT_APP_REPORTS_URL

const PurchaseOrderReports = () => {
    const currentDatetimeUTC = new Date().toISOString().slice(0, 16);
    const [searchLoader, setSearchLoader] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [emailModal, setEmailModal] = useState(false);
    const [dateFilter, setdateFilter] = useState(true);
    const [SupplierList, setSuppliers] = useState();
    const onCloseModal = () => setEmailModal(false);
    const [pagination, setPagination] = useState();
    const onOpenModal = () => setEmailModal(true);
    const [loading, setLoading] = useState(false);
    const [StockType, setStockType] = useState();
    const [pageSize, setPageSize] = useState(20);
    const { currencyPrecision } = useCurrency();
    const [rowData, setRowData] = useState([]);
    const apiService = new ApiService();
    const location = useLocation();
    const gridRef = useRef();
    const dashboardFilters = location.state || {};
    const [precision, setPrecision] = useState(currencyPrecision?.exp1 || 3);
    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    const StatusFilter = [
        { value: '0', label: 'Pending' },
        { value: '1', label: 'Approved' },
        { value: '4', label: 'Hold' },
        { value: '2', label: 'Rejected' },
        { value: '3', label: 'Cancelled' },
        { value: '6', label: 'Closed' },
    ];
    const FilterStatus = [
        { value: 'Partially Delivered', label: 'Partial Delievered' },
        { value: 'Completely Delivered', label: 'Completely Delivered' },
        { value: 'Not Delivered', label: 'Not Delivered' },
        { value: 'Closed', label: 'Closed' }
    ];
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };
    const [formData, setFormData] = useState({
        email: "",
        PoNum: "",
        fromDate: '',          // Today's date
        toDate: '',
        Filterby: [{ label: 'Select Delivery Status', value: '0' }],
        VendorName: [{ label: 'Select Supplier ', value: '0' }],
        StockType: [{ label: 'Select Stock Type', value: '0' }],
        Status: [{ label: 'Filter By', value: '' }],
        Cost1: [{ label: 'Select Stock Type', value: '0' }],
        Cost2: [{ label: 'Select Stock Type', value: '0' }],
        Cost3: [{ label: 'Select Stock Type', value: '0' }],
        Cost4: [{ label: 'Select Stock Type', value: '0' }],
        ItemType: [{ label: 'Select Stock Type', value: '0' }],
        Items: [{ label: 'Select Items', value: '0' }],
    });
    const handleClearFilters = () => {
        const today = new Date();
        setFormData({
            startdate: "",
            endDate: "",
            PoNum: "",
            fromDate: formatDate(today),
            toDate: formatDate(today),
            Filterby: [{ label: 'Select Delivery Status', value: '0' }],
            VendorName: [{ label: 'Select Supplier ', value: '0' }],
            StockType: [{ label: 'Select Stock Type', value: '0' }],
            Status: [{ label: 'Filter By', value: '' }],
            Cost1: [{ label: 'Select Stock Type', value: '0' }],
            Cost2: [{ label: 'Select Stock Type', value: '0' }],
            Cost3: [{ label: 'Select Stock Type', value: '0' }],
            Cost4: [{ label: 'Select Stock Type', value: '0' }],
            ItemType: [{ label: 'Select Stock Type', value: '0' }],
            Items: [{ label: 'Select Items', value: '0' }],
        });
        setdateFilter(false)

    };
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {

                const today = new Date();

                setFormData((prev) => ({
                    ...prev,
                    fromDate: formatDate(today),
                    toDate: formatDate(today),
                }));

                const apiService = new ApiService();
                let param = `?isActive=true`
                let Currencyres = await apiService.get('GET_CURRENCY_MASTER')
                const filteredDenominations = Currencyres?.data?.result?.find(currency => currency?.isDefault === true);
                setPrecision(filteredDenominations?.precision)
                const stockType = await apiService.getApiParamater("GET_STOCK_TYPE", param);
                setStockType(stockType?.data?.result);
                const suppliers = await apiService.get('GET_SUPPLIER');
                setSuppliers(suppliers?.data?.result);
                // const Items = await apiService.getApiParamater("GET_ITEM", param);
                // setItems(Items?.data?.result);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        fetchDropdownData();
    }, []);
    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                setLoading(true);
                const today = new Date();
                const selectedStatus = StatusFilter?.find((acc) => acc?.label === dashboardFilters?.status);
                setFormData((prev) => ({
                    ...prev,
                    fromDate: formatDate(dashboardFilters?.fromDate) || formatDate(today),
                    toDate: formatDate(dashboardFilters?.toDate) || formatDate(today),
                    Status: selectedStatus
                }));
                debugger

                const params = new URLSearchParams();
                params.append('VendorName', formData.VendorName.label || "");
                params.append('Status', selectedStatus?.value || "");
                params.append('Filter', formData.Filterby.value || "");
                params.append('ItemDescription', formData.Items?.label || "");
                params.append('CostCenter1', formData.Cost1?.label || "");
                params.append('CostCenter2', formData.Cost2?.label || "");
                params.append('CostCenter3', formData.Cost3?.label || "");
                params.append('CostCenter4', formData.Cost4?.label || "");
                params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
                params.append('PageNo', 1);
                params.append('PageSize', pageSize || 20);
                params.append('POrderNo', formData.PoNum || "");
                if (dateFilter === true) {
                    params.append('FromDate', formatDate(dashboardFilters?.fromDate) || "");
                    params.append('ToDate', formatDate(dashboardFilters?.toDate) || "");
                }

                const res = await apiService.getApiParamater('GET_PO_REPORT', `?${params.toString()}`);
                setRowData(res?.data?.result?.reverse() || []);
                setPagination(res.data.paginationData);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching dropdown data:', error);
            }
        };
        if (dashboardFilters?.fromDate) {
            fetchDropdownData();
        }
    }, [dashboardFilters]);
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('VendorName', formData.VendorName.label || "");
            params.append('Status', formData.Status.value || "");
            params.append('Filter', formData.Filterby.value || "");
            params.append('ItemDescription', formData.Items?.label || "");
            params.append('CostCenter1', formData.Cost1?.label || "");
            params.append('CostCenter2', formData.Cost2?.label || "");
            params.append('CostCenter3', formData.Cost3?.label || "");
            params.append('CostCenter4', formData.Cost4?.label || "");
            params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('POrderNo', formData.PoNum || "");
            if (dateFilter === true) {
                params.append('FromDate', formData?.fromDate || "");
                params.append('ToDate', formData?.toDate || "");
            }

            const res = await apiService.getApiParamater('GET_PO_REPORT', `?${params.toString()}`);
            setRowData(res?.data?.result?.reverse() || []);
            setPagination(res.data.paginationData);
            setLoading(false);
            setFormData((prev) => ({
                ...prev,
                fromDate: formData.fromDate,
                toDate: formData.toDate,
            }));
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const handleSearch = async () => {
        setSearchLoader(true);
        await getItems();
        setSearchLoader(false);
    }
    const dateFormatter = (params) => {
        const date = moment.utc(params.value || currentDatetimeUTC).local();
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const Comparison = [
        { headerName: 'PO No', field: 'pOrderNo', suppressMovable: true, width: 110 },
        { headerName: 'Qout Ref', field: 'quotationRef', suppressMovable: true, width: 110 },
        { headerName: 'Requisition NO ', field: 'requisitionNo', suppressMovable: true, width: 110, },
        {
            headerName: 'PO Date', field: 'docDate', suppressMovable: true, width: 130, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Vendor', field: 'vendorName', suppressMovable: true, width: 110 },
        { headerName: 'Payment Term', field: 'terms', suppressMovable: true, width: 110 },
        { headerName: 'Supplier Contact', field: 'attention', suppressMovable: true, width: 110 },
        { headerName: 'Department', field: 'department', suppressMovable: true, width: 110 },
        {
            headerName: 'Delivery Date', field: 'deliveryDate', suppressMovable: true, width: 150, filter: 'agDateColumnFilter',
            valueFormatter: dateFormatter,
            comparator: dateComparator,
        },
        { headerName: 'Curr Code', field: 'currencyCode', suppressMovable: true, width: 110 },
        { headerName: 'Exchange Rate', field: 'exchangeRate', suppressMovable: true, width: 110 },
        {
            headerName: 'Status', field: 'status', suppressMovable: true, width: 110,
            cellRenderer: function (params) {
                if (params.value === 0 || params.value === null) {
                    return <button class="btn pend ">Pending</button>;
                } else if (params.value === 1 || params.value === 4) {
                    return <button class="btn aproved">Approved</button>;
                } else if (params.value === 5 || params.value === null) {
                    return <button class="btn hold">Hold</button>;
                } else if (params.value === 2 || params.value === null) {
                    return <button class="btn reject">Rejected</button>;
                } else if (params.value === 3 || params.value === null) {
                    return <button class="btn pend">Cancelled</button>;
                } else if (params.value === 6 || params.value === null) {
                    return <button class="btn pend">Closed</button>;
                } else {
                    return params.value;
                }
            },
        },
        { headerName: 'Property', field: 'costCenter1', suppressMovable: true, width: 110 },
        { headerName: 'Unit', field: 'costCenter2', suppressMovable: true, width: 110 },
        // { headerName: 'Cost center 3', field: 'costCenter3', suppressMovable: true, width: 110 },
        // { headerName: 'Cost center 4', field: 'costCenter4', suppressMovable: true, width: 150 },
        { headerName: 'Delivery Status', field: 'deliveryStatus', suppressMovable: true, width: 110 },
        { headerName: 'Item Code', field: 'itemCode', suppressMovable: true, width: 110 },
        { headerName: 'Item Description', field: 'itemDescription', suppressMovable: true, width: 300 },
        { headerName: 'UOM', field: 'uom', suppressMovable: true, width: 110 },
        { headerName: 'QTY', field: 'qty', suppressMovable: true, width: 110 },
        {
            headerName: 'Unit Price', field: 'unitPrice', suppressMovable: true, width: 130,
            headerName: 'Unit Price', field: 'unitPrice', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(4)
        },
        { headerName: 'Vat %', field: 'vatPerc', suppressMovable: true, width: 110 },
        {
            headerName: 'Vat Amount', field: 'itemVatAmount', suppressMovable: true, width: 110,
            valueFormatter: (params) => params?.value?.toFixed(3)
        },
        {
            headerName: 'Amount', field: 'itemAmount', suppressMovable: true, width: 140,
            valueFormatter: (params) => params?.value?.toFixed(3)
        },
        {
            headerName: 'Net Amount', field: 'netAmount', suppressMovable: true, width: 140,
            valueFormatter: (params) => params?.value?.toFixed(3)
        },
        { headerName: 'GRN Qty', field: 'grnQty', suppressMovable: true, width: 150 },
        {
            headerName: 'GRN Balance Qty',
            valueGetter: params => (params.data.qty || 0) - (params.data.grnQty || 0),
            suppressMovable: true, width: 150
        },

    ];
    const onBtnCSVExport = useCallback(async (formdata, pagedata) => {

        setLoading(true);
        const params = new URLSearchParams();
        params.append('VendorName', formData.VendorName.label || "");
        params.append('Status', formData.Status.value || "");
        params.append('Filter', formData.Filterby.value || "");
        params.append('ItemDescription', formData.Items?.label || "");
        params.append('CostCenter1', formData.Cost1?.label || "");
        params.append('CostCenter2', formData.Cost2?.label || "");
        params.append('CostCenter3', formData.Cost3?.label || "");
        params.append('CostCenter4', formData.Cost4?.label || "");
        params.append('StockType', formData.StockType?.value?.stockTypeCode || "");
        params.append('PageNo', 1);
        params.append('PageSize', pagedata?.totalRecords || 10000);
        params.append('POrderNo', formData.PoNum || "");
        if (dateFilter === true) {
            params.append('FromDate', formData?.fromDate || "");
            params.append('ToDate', formData?.toDate || "");
        }

        const res = await apiService.getApiParamater('GET_PO_REPORT', `?${params.toString()}`);
        const allData = res?.data?.result || [];

        if (allData?.length > 0) {
            gridRef.current.api.setRowData(allData);

            gridRef.current.api.exportDataAsCsv({
                fileName: 'PurchaseOrderReport.csv',
                allColumns: true,
            });
            setLoading(false);
            toast.success("PurchaseOrderReport.csv downloaded")
        } else {
            toast.info("Please try Again")
        }
    }, []);
    const onBtPDFExport = useCallback(() => {
        const doc = new jsPDF();
        const rowData = [];
        const columnHeaders = [];
        const comparisonFields = [
            'recordId',
            'requisitionNo',
            'docDate',
            'vendorName',
            'terms',
            'status',
            'deliveryDate',
            'deliveryStatus',
            'itemCode',
            'itemDescription',
            'uom',
            'qty',
            'unitPrice',
        ];

        const translateStatus = (status) => {
            switch (status) {
                case 1:
                    return 'Approved';
                case 0:
                    return 'Pending';
                case 2:
                    return 'Hold';
                case 3:
                    return 'Rejected';
                default:
                    return status;
            }
        };

        comparisonFields.forEach(field => {
            const header = Comparison.find(col => col.field === field).headerName;
            columnHeaders.push(header);
        });

        gridRef.current.api.forEachNode((node) => {
            const row = [];
            comparisonFields.forEach(field => {
                let value = node.data[field];
                if (field === 'status') {
                    value = translateStatus(value);
                }
                row.push(value);
            });
            rowData.push(row);
        });

        const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
        doc.addFileToVFS("Poppins-Regular.ttf", poppinsFont);
        doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
        doc.setFont("Poppins");
        doc.setFontSize(18);
        doc.setTextColor(40, 40, 40);
        doc.text("Purchase Order Report", 72, 12);
        doc.text("__________________________", 60, 15);
        doc.autoTable({
            head: [columnHeaders],
            body: rowData,
            styles: {
                fontSize: 5,
            },
            headStyles: {
                fillColor: [209, 126, 6],
                textColor: [255, 255, 255],
                fontSize: 5,
            },
            columnStyles: {
                0: { cellWidth: 15 },
                1: { cellWidth: 15 },
                2: { cellWidth: 15 },
                3: { cellWidth: 15 },
                4: { cellWidth: 15 },
                5: { cellWidth: 15 },
                6: { cellWidth: 15 },
                7: { cellWidth: 20 },
                8: { cellWidth: 15 },
                9: { cellWidth: 15 },
                10: { cellWidth: 10 },
                11: { cellWidth: 10 },
                12: { cellWidth: 10 },
            },
            startY: 20
        });

        doc.save('PurchaseOrderReport.pdf');
    }, []);
    const onBtnExcelExport = useCallback(async (formdata, pagedata) => {
        try {
            setLoading(true);

            const params = new URLSearchParams();

            params.append("VendorName", formdata.VendorName?.label || "");
            params.append("Status", formdata.Status?.value || "");
            params.append("Filter", formdata.Filterby?.value || "");
            params.append("ItemDescription", formdata.Items?.label || "");
            params.append("CostCenter1", formdata.Cost1?.label || "");
            params.append("CostCenter2", formdata.Cost2?.label || "");
            params.append("CostCenter3", formdata.Cost3?.label || "");
            params.append("CostCenter4", formdata.Cost4?.label || "");
            params.append(
                "StockType",
                formdata.StockType?.value?.stockTypeCode || ""
            );

            params.append("PageNo", 1);
            params.append(
                "PageSize",
                pagedata?.totalRecords || 10000
            );

            params.append("POrderNo", formdata.PoNum || "");
            params.append("FromDate", formdata?.fromDate || "");
            params.append("ToDate", formdata?.toDate || "");

            const res = await apiService.getApiParamater(
                "GET_PO_REPORT",
                `?${params.toString()}`
            );

            const allData = res?.data?.result || [];

            if (!allData.length) {
                toast.info("No data found");
                return;
            }

            // ============================================================
            // TOTAL AMOUNT
            // ============================================================

            const totalAmount = allData.reduce(
                (sum, item) => {
                    return sum + Number(item.itemAmount || 0);
                },
                0
            );

            // ============================================================
            // NET AMOUNT SUM
            // ============================================================

            const totalNetAmount = allData.reduce(
                (sum, item) => {
                    return sum + Number(item.netAmount || 0);
                },
                0
            );

            // ============================================================
            // NET AMOUNT COUNT
            // Count rows having a Net Amount value
            // ============================================================

            const netAmountCount = allData.filter(
                (item) =>
                    item.netAmount !== null &&
                    item.netAmount !== undefined &&
                    item.netAmount !== ""
            ).length;

            // ============================================================
            // EXCEL DATA
            // ============================================================

            const excelData = allData.map((item) => ({
                "PO No": item.pOrderNo || "",
                "Qout Ref": item.quotationRef || "",
                "Requisition NO": item.requisitionNo || "",

                "PO Date": item.docDate
                    ? moment(item.docDate).format("DD-MMM-YYYY")
                    : "",

                "Vendor": item.vendorName || "",
                "Payment Term": item.terms || "",
                "Supplier Contact": item.attention || "",
                "Department": item.department || "",

                "Delivery Date": item.deliveryDate
                    ? moment(item.deliveryDate).format("DD-MMM-YYYY")
                    : "",

                "Curr Code": item.currencyCode || "",
                "Exchange Rate": item.exchangeRate || 0,

                "Status": item.status === 1 ? "Approved" : item.status === 0 ? "Pending" : item.status === 5 ? "Hold" : item.status === 6 ? "Closed" : item.status === 3 ? "Cancelled" : item.status === 4 ? "Approved" : "Rejected",

                "Property": item.costCenter1 || "",
                "Unit": item.costCenter2 || "",
                "Delivery Status": item.deliveryStatus || "",
                "Item Code": item.itemCode || "",
                "Item Description": item.itemDescription || "",
                "UOM": item.uom || "",

                "QTY": item.qty || 0,

                "Unit Price": Number(item.unitPrice || 0).toFixed(4),

                "Vat %": item.vatPerc || 0,

                "Vat Amount": Number(
                    item.itemVatAmount || 0
                ).toFixed(precision || 3),

                "Amount": Number(
                    item.itemAmount || 0
                ).toFixed(precision || 3),

                "Net Amount": Number(
                    item.netAmount || 0
                ).toFixed(precision || 3),

                "GRN Qty": item.grnQty || 0,

                "GRN Balance Qty": (
                    Number(item.qty || 0) -
                    Number(item.grnQty || 0)
                ).toFixed(3)
            }));

            // ============================================================
            // EMPTY ROW FOR SPACING
            // ============================================================

            excelData.push({});

            // ============================================================
            // TOTAL ROW
            // ============================================================

            const totalRow = {
                "PO No": "",
                "Qout Ref": "",
                "Requisition NO": "",
                "PO Date": "",
                "Vendor": "",
                "Payment Term": "",
                "Supplier Contact": "",
                "Department": "",
                "Delivery Date": "",
                "Curr Code": "",
                "Exchange Rate": "",
                "Status": "",
                "Property": "",
                "Unit": "",
                "Delivery Status": "",
                "Item Code": "",
                "Item Description": "",
                "UOM": "",
                "QTY": "",
                "Unit Price": "",
                "Vat %": "",

                "Vat Amount": "Total",

                "Amount": Number(
                    totalAmount || 0
                ).toFixed(precision || 3),

                // Net Amount Sum + Count
                "Net Amount": `Sum: ${Number(
                    totalNetAmount || 0
                ).toFixed(precision || 3)} | Count: ${netAmountCount}`,

                "GRN Qty": "",
                "GRN Balance Qty": ""
            };

            excelData.push(totalRow);

            // ============================================================
            // CREATE WORKSHEET
            // ============================================================

            const worksheet = XLSX.utils.json_to_sheet(excelData);

            // ============================================================
            // AUTO-FIT COLUMN WIDTHS
            // ============================================================

            const headers = Object.keys(excelData[0]);

            const columnWidths = headers.map((header) => {

                // Give Item Description more space
                if (header === "Item Description") {
                    return {
                        wch: 60
                    };
                }

                // Give Net Amount enough space for Sum + Count
                if (header === "Net Amount") {
                    return {
                        wch: 35
                    };
                }

                const maxLength = Math.max(
                    header.length,
                    ...excelData.map((row) => {
                        const value = row[header];

                        return value !== null &&
                            value !== undefined
                            ? value.toString().length
                            : 0;
                    })
                );

                return {
                    wch: Math.min(
                        Math.max(maxLength + 2, 10),
                        40
                    )
                };
            });

            worksheet["!cols"] = columnWidths;

            // ============================================================
            // TOTAL ROW STYLE
            // ============================================================

            const totalRowStyle = {
                font: {
                    bold: true
                },
                fill: {
                    fgColor: {
                        rgb: "E0E0E0"
                    }
                }
            };

            // ============================================================
            // APPLY TOTAL ROW STYLE
            // ============================================================

            const range = XLSX.utils.decode_range(
                worksheet["!ref"]
            );

            // Excel row index:
            // Header = row 0
            // Data rows
            // Empty row
            // Total row = last row
            const totalRowIndex = excelData.length;

            for (
                let C = range.s.c;
                C <= range.e.c;
                ++C
            ) {
                const cellAddress = XLSX.utils.encode_cell({
                    r: totalRowIndex,
                    c: C
                });

                if (worksheet[cellAddress]) {
                    worksheet[cellAddress].s = totalRowStyle;
                }
            }

            // ============================================================
            // CREATE WORKBOOK
            // ============================================================

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Purchase Order Report"
            );

            // ============================================================
            // DOWNLOAD EXCEL
            // ============================================================

            XLSX.writeFile(
                workbook,
                "POReport.xlsx"
            );

            toast.success(
                "POReport.xlsx downloaded"
            );

        } catch (err) {
            console.log("Excel Export Error:", err);

            toast.error(
                "Something went wrong"
            );

        } finally {
            setLoading(false);
        }
    }, [precision]);
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleStockChange = (selectedOption) => {
        setFormData({ ...formData, StockType: selectedOption });
    }
    const handleSupplierChange = (selectedOption) => {
        setFormData({ ...formData, VendorName: selectedOption });
    }
    const handleItemChange = (selectedOption) => {
        setFormData({ ...formData, Items: selectedOption });
    }
    const handleFilterbyChange = (selectedOption) => {
        setFormData({ ...formData, Filterby: selectedOption });
    }
    const handleStatusFilter = (selectedOption) => {
        setFormData({ ...formData, Status: selectedOption });
    }
    const handleDateFilterSelection = (e) => {
        setdateFilter(e);
    };
    const SendEmail = async () => {
        try {
            if (!formData.email) {
                toast.warning("Enter User Email to send Report")
                return;
            }
            const requestBody = {
                // toEmail: "shahzaibawan864@gmail.com",
                toEmail: formData.email,
                subject: "Purchase Order Report",
                body: `
                <div className='printhead2 mb-5 px-4'>
                    <table>
                        <thead className='dynoTable' style='background-color: #5B93FF; color: #fff;'>
                            <tr>
                                <th>PO No</th>
                                <th>Requisition NO </th>
                                <th>PO Date</th>
                                <th>Vendor</th>
                                <th>Payment Term</th>
                                <th>Supplier Contact</th>
                                <th>Department</th>
                                <th>Curr Code</th>
                                <th>status</th>
                                <th>Property</th>
                                <th>Unit</th>
                                <th>Cost center 3</th>
                                <th>Cost center 4</th>
                                <th>Delivery Status</th>
                                <th>Item Code</th>
                                <th>Item Description</th>
                                <th>UOM</th>
                                <th>QTY</th>
                                <th>Unit Price</th>
                                <th>Vat %</th>
                                <th>Vat Amount</th>
                                <th>Amount</th>
                                <th>Net Amount</th>
                                <th>GRN Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${rowData?.map((row, index) => `
                                <tr key=${index}>
                                    <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.pOrderNo}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.requisitionNo}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.docDate}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.vendorName}' /></td>
                                    <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.terms}' /></td>
                                    <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.attention}' /></td>
                                    <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.department}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.currencyCode}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.status}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter1}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter2}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter3}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.costCenter4}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.deliveryStatus}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemCode}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.itemDescription}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.uom}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.qty}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.unitPrice}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatPerc}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.vatAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(3) || 0}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.netAmount}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.grnQty}' disabled /></td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>`
            }
            const apiService = new ApiService();
            const response = await apiService.post("SEND_EMAIL", requestBody);
            if (response.status === 200) {
                onCloseModal()
                toast.success("Email send successfully")
                handleClearFilters()
            }

        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const handleShow = () => {
        {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: 'POListSummary' },
                    { name: 'PoNo', value: formData.PoNum || "" },
                    { name: 'VendorName', value: formData.VendorName.label || "" },
                    { name: 'FromDate', value: formData?.fromDate || '' },
                    { name: 'toDate', value: formData?.toDate || '' },
                    { name: 'Status', value: formData?.Status?.value || '5' },
                    { name: 'DeliveryStatus', value: formData?.Filterby?.label || 'All' },
                    { name: 'CostCenter1', value: formData.Cost1?.label || '' },
                ];


                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
        }
    }
    return (
        <div className='p-4'>
            <div className='gridBg m-0 row' style={{ borderRadius: "16px 16px 16px 16px" }}>
                <div className='col-9'>
                    <div className='row pb-2' >
                        <div className='col'>
                            <input
                                type='text'
                                className="form-Input w-100"
                                placeholder='PO No'
                                value={formData.PoNum}
                                name="PoNum"
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Status}
                                options={StatusFilter}
                                onChange={handleStatusFilter}
                            />
                        </div>
                        {/* <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                defaultValue={{ label: 'Item type', value: 'Select Sub Category' }}
                                options={staticOptions}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.Items}
                                onChange={(selectedOption) => handleItemChange(selectedOption)}
                                options={Items?.map((itm) => ({ value: itm, label: itm?.itemDescription }))}
                            />
                        </div> */}
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                onChange={(selectedOption) => handleFilterbyChange(selectedOption)}
                                value={formData.Filterby}
                                options={FilterStatus}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.VendorName}
                                onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                options={SupplierList?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                            />
                        </div>
                        <div className='col'>
                            <Select
                                className="p-0"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                        color: state.isFocused ? '#000 ' : '#000',
                                        ':hover': {
                                            backgroundColor: '#F5F5F5',
                                            color: '#000 ',
                                        },
                                    }),
                                }}
                                value={formData.StockType}
                                onChange={(selectedOption) => handleStockChange(selectedOption)}
                                options={StockType?.map((Stock) => ({ value: Stock, label: Stock?.stockTypeName }))}
                            />
                        </div>
                        {/* <div className='col gap-3 center'>
                            <input className="form-check-input"
                                type="checkbox"
                                id="dateFilter" style={{ width: "20px", height: "20px" }}
                                name="dateFilter"
                                checked={dateFilter}
                                onChange={(e) => handleDateFilterSelection(e.target.checked)} />
                            <label className=''>Date Filter</label>
                        </div> */}
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.fromDate}
                                // disabled={!dateFilter}
                                onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                                className="p-2 form-Input w-100"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                        <div className="d-flex justify-content-between start col">
                            <DatePicker
                                selected={formData.toDate}
                                onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                                className="p-2 form-Input w-100"
                                // disabled={!dateFilter}

                                dateFormat="dd-MM-yyyy"
                            />
                        </div>
                    </div>
                </div>
                <div className='col-3 '>
                    {searchLoader === true ?
                        <button className='mainbtnGry w-100' type="button"><ClipLoader color="#ffffff" size={25} /></button> :
                        <div onClick={handleSearch} className='mainbtnGry flex-end gap-2'>
                            <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                            <div className='center'>Search</div>
                        </div>
                    }
                    <div onClick={() => handleClearFilters()} className='mainbtnRed flex-end mt-2 gap-2'>
                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>Reset</div>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-between p-2 gridBg mt-2' style={{ borderRadius: "8px 8px 0px 0px " }}>
                <div className='mainInvHead center' >Purchase Order Report</div>
                <div className='d-flex gap-3 end'>
                    <div className='mainbtnGry flex-end gap-2'>
                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                            <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                                <PiDownloadSimple size={25} />
                            </DropdownToggle>
                            <DropdownMenu className='mt-3'>
                                <DropdownItem onClick={() => onBtnCSVExport(formData, pagination)} className='gap-3 d-flex center'><BsFiletypeCsv /><div>Export CSV</div></DropdownItem>
                                <DropdownItem onClick={() => onBtnExcelExport(formData, pagination)} className='gap-3 d-flex center'><LiaFileExcel /><div>Export Excel</div></DropdownItem>
                                <DropdownItem onClick={onBtPDFExport} className='gap-3 d-flex center'><BsFileEarmarkPdf /><div>Export PDF</div></DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                    <div className='mainbtn flex-end gap-1' onClick={handleShow}>
                        <div className='center'>Show</div>
                    </div>
                </div>
            </div>
            <div className='gridshad'>
                <div className="ag-theme-quartz" style={{ height: 550 }}>
                    {loading === true ?
                        <div className="center p-5">
                            <BarLoader color="#6E5199" height={3} width={200} />
                        </div>
                        :
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            rowSelection={'single'}
                            columnDefs={Comparison}
                            suppressExcelExport={true}
                            ref={gridRef}
                        />
                    }
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
            <Modal size="md"
                show={emailModal} onHide={() => onCloseModal()}
                onRequestClose={() => onCloseModal()}
                contentLabel='Email Modal'
                style={customStyles} closeButton
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Send Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input
                            type='email'
                            className="form-Input w-100"
                            id="validationCustom02"
                            value={formData.email}
                            name="email"
                            onChange={handleInputChange}
                            placeholder='Enter Email'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={SendEmail} >Save</button>
                </Modal.Footer>
            </Modal >
        </div>
    );
};
export default PurchaseOrderReports;
const customStyles = {
    content: {
        width: '30%', // Set the desired width
        height: '75%', // Set the desired 
        top: '50%', // Center vertically
        left: '50%', // Center horizontally
        right: '50%', // Center horizontally
        transform: 'translate(-50%, -50%)', // Center both vertically and horizontally
    },
};